var __getOwnPropNames = Object.getOwnPropertyNames;
var __commonJS = (cb, mod) => function __require() {
  try {
    return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
  } catch (e) {
    throw mod = 0, e;
  }
};

// server/utils/thermostatSchedule.js
var require_thermostatSchedule = __commonJS({
  "server/utils/thermostatSchedule.js"(exports, module) {
    var DAY_MINUTES = 24 * 60;
    var timeToMinutes = (time) => {
      if (!time) {
        return 0;
      }
      const [h, m] = time.split(":").map(Number);
      return h * 60 + (m || 0);
    };
    var minutesToTime = (mins) => {
      const m = (mins % DAY_MINUTES + DAY_MINUTES) % DAY_MINUTES;
      return `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;
    };
    var applySlotToDay = (existingDaySlots, dayOfWeek, newStart, newEnd, newPreset, newKey, excludeKey) => {
      const clampedEnd = Math.min(newEnd, DAY_MINUTES);
      const overflowMins = newEnd > DAY_MINUTES ? newEnd - DAY_MINUTES : 0;
      const slots = excludeKey ? existingDaySlots.filter((s) => s.key !== excludeKey) : existingDaySlots;
      const sortedByEnd = slots.slice().sort((a, b) => {
        const aEnd = timeToMinutes(a.end_time) || DAY_MINUTES;
        const bEnd = timeToMinutes(b.end_time) || DAY_MINUTES;
        return aEnd - bEnd;
      });
      let predecessorKey = null;
      let predecessorEnd = -1;
      sortedByEnd.forEach((s) => {
        const sEnd = timeToMinutes(s.end_time) || DAY_MINUTES;
        if (sEnd <= newStart && sEnd > predecessorEnd) {
          predecessorEnd = sEnd;
          predecessorKey = s.key;
        }
      });
      const adjusted = [];
      slots.forEach((s) => {
        const sStart = timeToMinutes(s.start_time);
        const sEndRaw = timeToMinutes(s.end_time);
        const sEnd = sEndRaw === 0 ? DAY_MINUTES : sEndRaw;
        if (sEnd <= newStart || sStart >= clampedEnd) {
          if (s.key === predecessorKey && sEnd < newStart) {
            adjusted.push({ ...s, end_time: minutesToTime(newStart) });
          } else {
            adjusted.push(s);
          }
        } else if (sStart < newStart && sEnd > clampedEnd) {
          adjusted.push({ ...s, end_time: minutesToTime(newStart) });
          adjusted.push({ ...s, start_time: minutesToTime(clampedEnd), key: `split-${s.key}` });
        } else if (sStart < newStart) {
          adjusted.push({ ...s, end_time: minutesToTime(newStart) });
        } else if (sEnd > clampedEnd) {
          adjusted.push({ ...s, start_time: minutesToTime(clampedEnd) });
        }
      });
      adjusted.push({
        day_of_week: dayOfWeek,
        start_time: minutesToTime(newStart),
        end_time: minutesToTime(clampedEnd),
        preset: newPreset,
        key: newKey
      });
      const overflowSlot = overflowMins > 0 ? {
        start_time: "00:00",
        end_time: minutesToTime(overflowMins),
        preset: newPreset,
        key: `overflow-${newKey}`
      } : null;
      return { fixedSlots: adjusted, overflowSlot };
    };
    var mergeIntoSlots = (allSlots, dayOfWeek, taggedFixed, overflowSlot) => {
      if (!overflowSlot) {
        return [...allSlots.filter((s) => s.day_of_week !== dayOfWeek), ...taggedFixed];
      }
      const nextDay = (dayOfWeek + 1) % 7;
      const overflowEnd = timeToMinutes(overflowSlot.end_time) || DAY_MINUTES;
      const nextDayKept = [];
      allSlots.filter((s) => s.day_of_week === nextDay).forEach((s) => {
        const sStart = timeToMinutes(s.start_time);
        const sEndRaw = timeToMinutes(s.end_time);
        const sEnd = sEndRaw === 0 ? DAY_MINUTES : sEndRaw;
        if (sStart >= overflowEnd) {
          nextDayKept.push(s);
          return;
        }
        if (sEnd > overflowEnd) {
          nextDayKept.push({ ...s, start_time: minutesToTime(overflowEnd) });
        }
      });
      const otherDays = allSlots.filter((s) => s.day_of_week !== dayOfWeek && s.day_of_week !== nextDay);
      return [...otherDays, ...taggedFixed, ...nextDayKept, { ...overflowSlot, day_of_week: nextDay }];
    };
    var readDayAsEntered = (allSlots, dayOfWeek) => {
      const nextDay = (dayOfWeek + 1) % 7;
      const daySlots = allSlots.filter((s) => s.day_of_week === dayOfWeek);
      const nextDaySlots = allSlots.filter((s) => s.day_of_week === nextDay);
      return daySlots.map((slot) => {
        const endsAtMidnight = timeToMinutes(slot.end_time) === 0;
        if (!endsAtMidnight) {
          return slot;
        }
        const overflow = nextDaySlots.find(
          (s) => timeToMinutes(s.start_time) === 0 && s.preset === slot.preset && timeToMinutes(s.end_time) !== 0
        );
        if (!overflow) {
          return slot;
        }
        return { ...slot, end_time: overflow.end_time, overnight: true };
      });
    };
    var copyDayOntoDays = (allSlots, sourceDay, targetDays, makeKey) => {
      const sourceSlots = readDayAsEntered(allSlots, sourceDay).slice().sort((a, b) => {
        return timeToMinutes(a.start_time) - timeToMinutes(b.start_time);
      });
      let result = allSlots.filter((s) => !targetDays.includes(s.day_of_week));
      const daysToFill = targetDays.includes((sourceDay + 1) % 7) ? [...targetDays, sourceDay] : targetDays;
      daysToFill.forEach((targetDay) => {
        sourceSlots.forEach((slot) => {
          const start = timeToMinutes(slot.start_time);
          const rawEnd = timeToMinutes(slot.end_time) || DAY_MINUTES;
          const end = slot.overnight ? rawEnd + DAY_MINUTES : rawEnd;
          const existing = result.filter((s) => s.day_of_week === targetDay);
          const { fixedSlots, overflowSlot } = applySlotToDay(
            existing,
            targetDay,
            start,
            end,
            slot.preset,
            makeKey(),
            null
          );
          const taggedFixed = fixedSlots.map((s) => ({ ...s, day_of_week: targetDay }));
          result = mergeIntoSlots(result, targetDay, taggedFixed, overflowSlot);
        });
      });
      return result;
    };
    var parseEnd = (timeStr) => {
      const v = timeToMinutes(timeStr);
      return v === 0 ? DAY_MINUTES : v;
    };
    var WEEKDAY_INDEX = { Mon: 0, Tue: 1, Wed: 2, Thu: 3, Fri: 4, Sat: 5, Sun: 6 };
    var getCurrentDayAndMinutes = (now = /* @__PURE__ */ new Date(), timezone = null) => {
      let weekday = null;
      let hours = null;
      let minutes = null;
      if (timezone) {
        try {
          const parts = new Intl.DateTimeFormat("en-US", {
            timeZone: timezone,
            weekday: "short",
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
          }).formatToParts(now);
          const get = (type) => parts.find((part) => part.type === type).value;
          const parsedWeekday = WEEKDAY_INDEX[get("weekday")];
          const parsedHours = parseInt(get("hour"), 10) % 24;
          const parsedMinutes = parseInt(get("minute"), 10);
          weekday = parsedWeekday;
          hours = parsedHours;
          minutes = parsedMinutes;
        } catch (e) {
        }
      }
      if (weekday === null) {
        weekday = (now.getDay() + 6) % 7;
        hours = now.getHours();
        minutes = now.getMinutes();
      }
      return {
        dayOfWeek: weekday,
        yesterdayOfWeek: (weekday + 6) % 7,
        currentMinutes: hours * 60 + minutes
      };
    };
    var findMatchingSlot = (todaySlots, yesterdaySlots, currentMinutes) => {
      const matchedToday = todaySlots.find((slot) => {
        const slotStart = timeToMinutes(slot.start_time);
        const slotEnd = parseEnd(slot.end_time);
        return slotEnd > slotStart && currentMinutes >= slotStart && currentMinutes < slotEnd;
      });
      if (matchedToday) {
        return matchedToday;
      }
      const matchedOvernightStart = todaySlots.find((slot) => {
        const slotStart = timeToMinutes(slot.start_time);
        const slotEnd = timeToMinutes(slot.end_time);
        return slotEnd < slotStart && currentMinutes >= slotStart;
      });
      if (matchedOvernightStart) {
        return matchedOvernightStart;
      }
      const matchedOvernightEnd = yesterdaySlots.find((slot) => {
        const slotStart = timeToMinutes(slot.start_time);
        const slotEnd = timeToMinutes(slot.end_time);
        return slotEnd < slotStart && currentMinutes < slotEnd;
      });
      return matchedOvernightEnd || null;
    };
    var findMatchingPreset = (todaySlots, yesterdaySlots, currentMinutes) => {
      const slot = findMatchingSlot(todaySlots, yesterdaySlots, currentMinutes);
      return slot ? slot.preset : null;
    };
    var findCurrentTransition = (transitions, dayOfWeek, currentMinutes) => {
      if (!transitions || transitions.length === 0) {
        return null;
      }
      const sorted = [...transitions].sort(
        (a, b) => a.day_of_week - b.day_of_week || timeToMinutes(a.time) - timeToMinutes(b.time)
      );
      const nowPosition = dayOfWeek * DAY_MINUTES + currentMinutes;
      const positionOf = (transition) => transition.day_of_week * DAY_MINUTES + timeToMinutes(transition.time);
      let current = null;
      sorted.forEach((transition) => {
        if (positionOf(transition) <= nowPosition) {
          current = transition;
        }
      });
      return current || sorted[sorted.length - 1];
    };
    var findNextTransition = (transitions, dayOfWeek, currentMinutes) => {
      const current = findCurrentTransition(transitions, dayOfWeek, currentMinutes);
      if (!current) {
        return null;
      }
      const sorted = [...transitions].sort(
        (a, b) => a.day_of_week - b.day_of_week || timeToMinutes(a.time) - timeToMinutes(b.time)
      );
      const index = sorted.findIndex(
        (transition) => transition.day_of_week === current.day_of_week && transition.time === current.time
      );
      return sorted[(index + 1) % sorted.length];
    };
    var nextTransitionTimestamp = (transitions, now = /* @__PURE__ */ new Date(), timezone = null) => {
      if (!transitions || transitions.length === 0) {
        return null;
      }
      const { dayOfWeek, currentMinutes } = getCurrentDayAndMinutes(now, timezone);
      const next = findNextTransition(transitions, dayOfWeek, currentMinutes);
      const nowPosition = dayOfWeek * DAY_MINUTES + currentMinutes;
      const nextPosition = next.day_of_week * DAY_MINUTES + timeToMinutes(next.time);
      const minutesAway = nextPosition > nowPosition ? nextPosition - nowPosition : 7 * DAY_MINUTES - nowPosition + nextPosition;
      const startOfMinute = now.getTime() - now.getTime() % (60 * 1e3);
      return startOfMinute + minutesAway * 60 * 1e3;
    };
    var carriedPresetByDay = (transitions) => {
      const byDay = {};
      for (let day = 0; day < 7; day += 1) {
        byDay[day] = null;
      }
      if (!transitions || transitions.length === 0) {
        return byDay;
      }
      for (let day = 0; day < 7; day += 1) {
        const ownPoints = transitions.filter((transition) => transition.day_of_week === day).map((transition) => timeToMinutes(transition.time)).sort((a, b) => a - b);
        const startsOnItsOwnPoint = ownPoints.length > 0 && ownPoints[0] === 0;
        const inherited = startsOnItsOwnPoint ? null : findCurrentTransition(transitions, day, 0);
        const lastOfWeek = [...transitions].sort(
          (a, b) => a.day_of_week - b.day_of_week || timeToMinutes(a.time) - timeToMinutes(b.time)
        )[transitions.length - 1];
        const wrapsOntoItself = inherited && inherited.day_of_week === lastOfWeek.day_of_week && inherited.time === lastOfWeek.time;
        byDay[day] = inherited && (inherited.day_of_week !== day || wrapsOntoItself) ? {
          preset: inherited.preset,
          day: inherited.day_of_week,
          until: ownPoints.length > 0 ? ownPoints[0] : DAY_MINUTES
        } : null;
      }
      return byDay;
    };
    module.exports = {
      findCurrentTransition,
      findNextTransition,
      carriedPresetByDay,
      nextTransitionTimestamp,
      applySlotToDay,
      mergeIntoSlots,
      readDayAsEntered,
      copyDayOntoDays,
      timeToMinutes,
      minutesToTime,
      parseEnd,
      getCurrentDayAndMinutes,
      findMatchingSlot,
      findMatchingPreset,
      DAY_MINUTES
    };
  }
});

// server/utils/thermostatRanges.js
var require_thermostatRanges = __commonJS({
  "server/utils/thermostatRanges.js"(exports, module) {
    var { timeToMinutes } = require_thermostatSchedule();
    var STOP_PRESET = "off";
    function transitionsToRanges(transitions) {
      if (!transitions || transitions.length === 0) {
        return [];
      }
      const sorted = [...transitions].sort(
        (a, b) => a.day_of_week - b.day_of_week || timeToMinutes(a.time) - timeToMinutes(b.time)
      );
      const ranges = [];
      sorted.forEach((transition, index) => {
        const next = sorted[(index + 1) % sorted.length];
        const startMinutes = timeToMinutes(transition.time);
        const endMinutes = timeToMinutes(next.time);
        const wrapsWholeWeek = sorted.length === 1;
        const endsNextDay = wrapsWholeWeek || next.day_of_week !== transition.day_of_week || endMinutes <= startMinutes;
        ranges.push({
          day_of_week: transition.day_of_week,
          start_time: transition.time,
          end_time: wrapsWholeWeek ? transition.time : next.time,
          preset: transition.preset,
          ends_next_day: endsNextDay
        });
      });
      return ranges;
    }
    function rangesToTransitions(ranges) {
      if (!ranges || ranges.length === 0) {
        return [];
      }
      const opens = /* @__PURE__ */ new Map();
      const closes = /* @__PURE__ */ new Map();
      const key = (day, time) => `${day}-${time}`;
      ranges.forEach((range) => {
        const startKey = key(range.day_of_week, range.start_time);
        opens.set(startKey, { day_of_week: range.day_of_week, time: range.start_time, preset: range.preset });
        if (range.preset === STOP_PRESET) {
          return;
        }
        const startMinutes = timeToMinutes(range.start_time);
        const endMinutes = timeToMinutes(range.end_time);
        const endsNextDay = endMinutes <= startMinutes;
        const endDay = endsNextDay ? (range.day_of_week + 1) % 7 : range.day_of_week;
        closes.set(key(endDay, range.end_time), {
          day_of_week: endDay,
          time: range.end_time,
          preset: STOP_PRESET
        });
      });
      const transitions = [...opens.values()];
      closes.forEach((close, closeKey) => {
        if (!opens.has(closeKey)) {
          transitions.push(close);
        }
      });
      const sorted = transitions.sort(
        (a, b) => a.day_of_week - b.day_of_week || timeToMinutes(a.time) - timeToMinutes(b.time)
      );
      const coversMondayMorning = ranges.some((range) => {
        const crossesMidnight = timeToMinutes(range.end_time) <= timeToMinutes(range.start_time);
        if (crossesMidnight) {
          return range.day_of_week === 6;
        }
        return range.day_of_week === 0 && timeToMinutes(range.start_time) === 0;
      });
      if (!coversMondayMorning) {
        sorted.unshift({ day_of_week: 0, time: "00:00", preset: STOP_PRESET });
      }
      return sorted;
    }
    module.exports = { transitionsToRanges, rangesToTransitions, STOP_PRESET };
  }
});
const __cjsModule = require_thermostatRanges();
export default __cjsModule;
export const transitionsToRanges = __cjsModule.transitionsToRanges;
export const rangesToTransitions = __cjsModule.rangesToTransitions;
export const STOP_PRESET = __cjsModule.STOP_PRESET;
